module.exports = {
  path: '//parking',
  list: {
    path: '/',
    get: true
  }
};
